import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        inAppBar: {
            listStyleType: 'none',
            height: '40px',
            margin: '0px',
            padding: 0
        },
        icon: {
            verticalAlign: 'text-bottom',
            marginRight: '5px'
        },
        itemClass: {
            float: 'left',
            display: 'block',
            width: '100px',
            color: theme.palette.text.disabled,
            fontSize: '14px',
            fontWeight: 500,
            textAlign: 'center',
            height: '20px',
            padding: '12px 12px 8px 12px',
            backgroundColor: 'transparent',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        selected: {
            float: 'left',
            display: 'block',
            fontSize: '14px',
            fontWeight: 500,
            height: '20px',
            padding: '12px 12px 8px 12px',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            textAlign: 'center',
            color: theme.palette.primary.main,
            width: '100px',
            backgroundColor: 'white',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }, globalStyles);
};

class InAppBar extends React.Component {

    render() {

        const { tabValue, onChangeTab, tabItems, classes, size, split, background } = this.props;

        return (
            <ul
                className={classes.inAppBar}
                style={background ? { backgroundColor: '#f5f5f5' } : {}}
                data-test={"menu-selected-" + tabItems[tabValue].label}>
                {tabItems.map((item, index) => {
                    const selected = index === tabValue;
                    const itemClass = selected ? classes.selected : classes.itemClass;
                    const Icon = item.icon || null;
                    if (item.disabled) return null;
                    return <li
                        key={index}
                        data-test={"menu-option-" + item.label}
                        style={size === "small" ?
                            {
                                width: 'auto',
                                ...(split <= index) ? {
                                    float: 'right'
                                } : {}
                            }
                            :
                            {
                                ...(split <= index) ? { float: 'right' } : {}
                            }}
                        className={itemClass}
                        onClick={() => onChangeTab && onChangeTab(index)}>
                        {Icon && <Icon className={classes.icon} fontSize="small" />}
                        <span>
                            {item.label}
                        </span>
                    </li>;
                })}
            </ul>
        );
    }
}

InAppBar.defaultProps = {
    tabValue: 0,
    split: 999,
    size: "small",
    onChangeTab: null,
    background: true
};

InAppBar.propTypes = {
    tabValue: PropTypes.number,
    background: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium"]),
    tabItems: PropTypes.array.isRequired,
    split: PropTypes.number,
    onChangeTab: PropTypes.func,
    classes: PropTypes.object
};

export default withStyles(styles)(InAppBar);